import React from 'react'

export default ({ workSummary, onWorkSummaryClick }) => (
  <div
    className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer border border-gray-200 hover:border-[#aa6326] p-4"
    onClick={() => onWorkSummaryClick(workSummary)}
  >
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div className="flex-1">
        <p className="text-lg font-semibold text-gray-800">
          {workSummary.staff.firstName} {workSummary.staff.lastName}
        </p>
      </div>
      <div className="flex flex-col sm:text-left space-y-1">
        <p className="text-sm text-gray-600">
          <span className="font-medium">Incoming:</span>{' '}
          {workSummary.incomingJobCount}
        </p>
        <p className="text-sm text-gray-600">
          <span className="font-medium">Completed:</span>{' '}
          {workSummary.completedJobCount}
        </p>
      </div>
    </div>
  </div>
)
